import type { AiModel } from '@/api/aiModels';
import type { AiProvider } from '@/api/aiProviders';

/** Buckets models by their provider. A provider with no models has no key. */
export function groupModelsByProvider(models: AiModel[]): Record<string, AiModel[]> {
  const out: Record<string, AiModel[]> = {};
  for (const m of models) (out[m.provider] ??= []).push(m);
  return out;
}

/** Provider ids to auto-expand: those with a configured key (source !== 'none'). */
export function defaultOpenPanels(providers: AiProvider[]): string[] {
  return providers.filter((p) => p.source !== 'none').map((p) => p.provider);
}
